/**
 * DocViewSchema for TikTok Listing DocType
 *
 * Editable detail page for marketplace-synced TikTok product data.
 * Single-tab layout with iPad Settings card sections.
 * All sections use shared marketplace widgets with "TikTok Shop" channel config.
 *
 * The TikTokEditOverlayWidget at the end renders the floating Save pill
 * via a portal — it doesn't affect scroll layout.
 */

import type { DocViewSchema } from "./types";

export const tiktokListingDocViewSchema: DocViewSchema = {
  doctype: "TikTok Listing",
  views: {
    experience: {
      style: "shopify",
      sections: [
        { id: "sync-status", label: "Sync Status", widgetId: "MarketplaceSyncStatusWidget", description: "TikTok Shop" },
        { id: "images", label: "Product Images", widgetId: "MarketplaceImagesWidget", description: "TikTok Shop" },
        { id: "product-info", label: "Product Info", widgetId: "MarketplaceProductInfoWidget", description: "TikTok Shop" },
        { id: "product-attributes", label: "Product Attributes", widgetId: "ProductAttributesCard", description: "TikTok Shop" },
        { id: "pricing", label: "Pricing", widgetId: "MarketplacePricingWidget", description: "TikTok Shop" },
        { id: "inventory", label: "Inventory", widgetId: "MarketplaceInventoryWidget", description: "TikTok Shop" },
        { id: "package", label: "Package & Logistics", widgetId: "MarketplacePackageWidget", description: "TikTok Shop" },
        { id: "linked-item", label: "Linked Item", widgetId: "MarketplaceLinkedItemWidget", description: "TikTok Shop" },
        { id: "description", label: "Description", widgetId: "MarketplaceDescriptionWidget", description: "TikTok Shop" },
        { id: "danger-zone", label: "Danger Zone", widgetId: "TikTokDangerZoneWidget", description: "TikTok Shop" },
        { id: "edit-overlay", label: "", widgetId: "TikTokEditOverlayWidget", description: "TikTok Shop" },
      ],
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["sync-status", "images", "product-info", "product-attributes", "pricing", "inventory", "package", "linked-item", "description", "danger-zone", "edit-overlay"],
        },
      ],
    },
  },
};
